import Image from 'next/image';

import Imagem1 from '@/images/Pages/Index/HeroSection/imagem1.png';
import Imagem2 from '@/images/Pages/Index/HeroSection/imagem2.png';
import Imagem3 from '@/images/Pages/Index/HeroSection/imagem3.png';
import Imagem4 from '@/images/Pages/Index/HeroSection/imagem4.png';

import {
  Container,
  CarouselContainer,
  CustomArrow,
  CarouselItem,
} from './styles';

import { ImArrowRight2, ImArrowLeft2 } from 'react-icons/im';

interface IArrow {
  onClick: any;
  isLeft?: boolean;
}

const slides: { id: string; foto: StaticImageData; frase?: string }[] = [
  { id: 'imagem1', foto: Imagem1, frase: 'Encurtando distâncias' },
  { id: 'imagem2', foto: Imagem2 },
  { id: 'imagem3', foto: Imagem3 },
  { id: 'imagem4', foto: Imagem4 },
  // { id: 'imagem5', foto: Imagem5 },
  // { id: 'imagem6', foto: Imagem6 },
  // { id: 'imagem7', foto: Imagem7 },
];

const HeroSection: React.FC = (): JSX.Element => {
  return (
    <Container>
      <CarouselContainer
        infiniteLoop
        autoPlay
        swipeable
        emulateTouch
        showThumbs={false}
        interval={5000}
        renderArrowNext={(onClickHandler) => <Arrow onClick={onClickHandler} />}
        renderArrowPrev={(onClickHandler) => (
          <Arrow onClick={onClickHandler} isLeft />
        )}
      >
        {slides.map(({ foto, frase, id }) => (
          <CarouselItem key={id}>
            <Image
              src={foto}
              alt="Foto de caminhões da Delps realizando uma viagem"
              quality={100}
              placeholder="blur"
            />
            {!!frase && (
              <div className="text">
                <h2>{frase}</h2>
              </div>
            )}
          </CarouselItem>
        ))}
      </CarouselContainer>
    </Container>
  );
};

const Arrow: React.FC<IArrow> = ({ isLeft, onClick, ...rest }): JSX.Element => {
  return (
    <CustomArrow
      {...rest}
      onClick={onClick}
      isLeft={isLeft}
      aria-label={
        isLeft ? 'Botão para foto passada' : 'Botão para próxima foto'
      }
    >
      {isLeft ? <ImArrowLeft2 size={30} /> : <ImArrowRight2 size={30} />}
    </CustomArrow>
  );
};

export default HeroSection;
